import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Image } from '@/components/client';
interface FixedImageProps {
  src: string;
  label?: string;
  sizes?: string;
  className?: string;
  imageClassName?: string;
}
export const FixedImage = t0 => {
  const $ = _c(10);
  const {
    src,
    label,
    sizes: t1,
    className,
    imageClassName: t2
  } = t0;
  const sizes = t1 === undefined ? "(max-width: 1279px) 100vw, 1200px" : t1;
  const imageClassName = t2 === undefined ? "object-cover" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("relative block shrink-0 overflow-hidden", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = label ?? "";
  let t5;
  if ($[2] !== imageClassName || $[3] !== sizes || $[4] !== src || $[5] !== t4) {
    t5 = <Image src={src} alt={t4} fill={true} sizes={sizes} quality={75} className={imageClassName} />;
    $[2] = imageClassName;
    $[3] = sizes;
    $[4] = src;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <span className={t3}>{t5}</span>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};